import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutocompleteItemDirective } from './autocomplete-item.directive';

@NgModule({
  declarations: [
    AutocompleteItemDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    AutocompleteItemDirective
  ]
})
export class AutocompleteItemModule { }
